import React, { createContext, useState, useReducer, useEffect } from 'react';

import { ThemeContext } from 'contexts/themeContext';
import { UserContext } from 'contexts/userContext';
import RouteReducer, { InitialtRoute, RouteAction } from './routeReducer';
import { getLocalToken } from 'services/WService';
import {
  reducer as sideBarReducer,
  searchByRoute,
  selectActive,
  inactiveAll,
  setPermisions,
  hideChildlessNodes
} from 'hooks/useSideBar';
import sidebarConfig from 'sidebarConfig';

const AppContext = createContext();

const AppProvider = ({ children }) => {
  const [name, setName] = useState('TVendo');
  const [logoText, setlogoText] = useState('TVendo');
  const [company, setCompany] = useState(' Distribuidor');
  const localToken = getLocalToken();
  const [token, setToken] = useState(localToken);
  const [routeState, routeDispacher] = useReducer(RouteReducer, InitialtRoute);
  const [sideBarState, sideBarDispatch] = useReducer(sideBarReducer, {});

  const getSidebarConfig = ({ permissions, location, type }) => {
    const nodes = sideBarState.nodes;
    let authoridezRoutes = [];
    if (permissions) {
      authoridezRoutes = routeState.paths.filter(
        (element) => !element.permission || permissions.includes(element.permission)
      );
    }
    // console.log(authoridezRoutes);
    let selectedNode = location;
    if (type === 'location') {
      const node = sideBarState.indexed.find(
        (element) => element.path === (location.endsWith('/') ? location : (location += '/'))
      );
      if (node) selectedNode = node.key;
    }
    const allowedRoutes = authoridezRoutes?.map((item) => item.fullPath);
    setPermisions({ nodes, permissions: allowedRoutes });
    inactiveAll(nodes);

    hideChildlessNodes({ nodes });
    hideChildlessNodes({ nodes });
    selectActive({
      nodes,
      path: selectedNode,
      type: 'node',
      permissions: authoridezRoutes
    });
    nodes.forEach((node) => {
      if (node.children && Array.isArray(node.children)) {
        const existsOpens = node.children.filter((element) => element.open === true);
        node.open = existsOpens.length > 0;
      }
    });
    return nodes;
  };

  const selectActiveRoute = (location) => {
    if (!location) {
      location = '/';
    }
    inactiveAll(sideBarState.nodes);

    const selected = searchByRoute(sideBarState.indexed, location);
    if (selected?.found) {
      selectActive(sideBarState.nodes, location);
    }
  };

  useEffect(() => {
    sideBarDispatch({
      type: 'INITIALIZE',
      payload: {
        config: sidebarConfig
      }
    });
  }, []);

  return (
    <AppContext.Provider
      value={{
        name,
        logoText,
        company,
        token,
        setToken,
        routeState,
        routeDispacher,
        getSidebarConfig,
        selectActiveRoute
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const WithApp = (Child) => (props) => (
  <AppContext.Consumer>
    {(appContext) => (
      <ThemeContext.Consumer>
        {(themeContext) => (
          <UserContext.Consumer>
            {(userContext) => (
              <Child
                key={1}
                {...props}
                appContext={appContext}
                themeContext={themeContext}
                userContext={userContext}
              />
            )}
          </UserContext.Consumer>
        )}
      </ThemeContext.Consumer>
    )}
  </AppContext.Consumer>
);

export { AppProvider, WithApp, AppContext };
